import { render, staticRenderFns } from "./addlink.vue?vue&type=template&id=2dd572d4&scoped=true"
import script from "./addlink.vue?vue&type=script&lang=js"
export * from "./addlink.vue?vue&type=script&lang=js"
import style0 from "./addlink.vue?vue&type=style&index=0&id=2dd572d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd572d4",
  null
  
)

export default component.exports